export const defaultChannels = {
  'Esporte Interativo': {
    channelUrl:
      'https://www.eiplus.com.br/assinatura/?utm_source=Portal&utm_medium=PgProgramacao&utm_campaign=EI_0_Canal&utm_content=Assine_0_11880_PA_0_6_Retangulo',
  },
  'Esporte Interativo 2': {
    channelUrl:
      'https://www.eiplus.com.br/assinatura/?utm_source=Portal&utm_medium=PgProgramacao&utm_campaign=EI2_0_Canal&utm_content=Assine_0_11880_PA_0_6_Retangulo',
  },
  'Esporte Interativo BR': {
    channelUrl:
      'https://www.eiplus.com.br/assinatura/?utm_source=Portal&utm_medium=PgProgramacao&utm_campaign=EIBR_0_Canal&utm_content=Assine_0_11880_PA_0_6_Retangulo',
  },
}

const defaultChannelData = {
  channel: {
    name: '',
  },
  schedule: [
    {
      shows: [],
    },
  ],
}
const tvScheduleEmptyDay = {
  currentChannel: {
    name: 'Esporte Interativo',
  },
  channels: Object.keys(defaultChannels).map(channelName => ({
    ...defaultChannelData,
    ...{ channel: { name: channelName } },
  })),
}

export default tvScheduleEmptyDay



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/tv_channel_selection/tvScheduleEmptyDay.js